import { h } from 'preact'

export const DashboardTimezoneDisclaimer = () => (
  <div className='dashboard-timezone-disclaimer'>This dashboard is displayed in UTC time.</div>
)
